import { render, staticRenderFns } from "./OrganizationSwitcherMenu.vue?vue&type=template&id=4fec7970&"
import script from "./OrganizationSwitcherMenu.vue?vue&type=script&lang=js&"
export * from "./OrganizationSwitcherMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports